export default __webpack_public_path__ + "static/media/0xe0b22e0037b130a9f56bbb537684e6fa18192341.462b69c5.svg";